new (window as Window).Swiper('.block-image-link-boxes__slider', {
	slidesPerView: 1.4,
	spaceBetween: 20,
	loop: false,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
});
